import { siteInfo } from '@/mocks/feed';

export default function AboutIntro() {
  return (
    <section className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
      <div className="lg:col-span-7">
        <h1 className="font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
          我们是一群把夜晚当白天过的人
        </h1>
        <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
          {siteInfo.name} 从一次偶然的通宵开始。那天凌晨三点，一条消息在两个小时内传遍了所有群聊，
          但第二天早上大家才发现，所谓"内部消息"的源头只是一句没有任何信息量的模糊发言。
          我们决定做点事：把夜里的东西先记下来，按时间排好，天亮之后再回头核对。
        </p>
        <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
          现在的 {siteInfo.name} 有五档值夜时段，覆盖从午夜到清晨的整条时间线。
          我们不生产消息，也不评价任何人，只负责把"什么时候出现了什么、后来发生了什么变化"整理清楚，
          让你在凌晨看到一条内容时，至少知道它走到了哪一步。
        </p>

        <dl className="mt-8 grid grid-cols-2 gap-5 sm:grid-cols-3">
          <div>
            <dt className="font-display text-3xl tracking-wide text-accent-400">5</dt>
            <dd className="mt-1 text-xs text-foreground-600">值夜时段分档</dd>
          </div>
          <div>
            <dt className="font-display text-3xl tracking-wide text-accent-400">24h</dt>
            <dd className="mt-1 text-xs text-foreground-600">不间断整理</dd>
          </div>
          <div>
            <dt className="font-display text-3xl tracking-wide text-accent-400">0</dt>
            <dd className="mt-1 text-xs text-foreground-600">指向真实个人的描述</dd>
          </div>
        </dl>
      </div>

      <div className="lg:col-span-5">
        <div className="h-[320px] w-full overflow-hidden rounded-lg border border-background-200/70 md:h-[440px]">
          <img
            src="https://readdy.ai/api/search-image?query=night%20desk%20with%20laptop%20glowing%20warm%20amber%20light%2C%20notebook%20and%20coffee%20cup%20in%20a%20dark%20quiet%20room%2C%20moody%20editorial%20still%20life%20photography%2C%20deep%20shadows&width=800&height=1000&seq=nightgossip-about-01&orientation=portrait"
            alt="深夜编辑部桌面上亮着的屏幕与笔记本"
            className="h-full w-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}